import { useState } from 'react';
import { safeStorage } from '@/shared/utils/safeStorage';

type DialogState = 'auto' | 'dismissed' | 'reopened';

export type PreparationDialogSource = 'newcomer' | 'requested';

interface Options {
  guides: boolean;
  isNewcomer: boolean;
  userId: number | null;
}

export interface UseGuidedPreparationDialogReturn {
  isOpen: boolean;
  source: PreparationDialogSource;
  open: () => void;
  close: () => void;
}

const seenKey = (userId: number) => `preparation_dialog_seen_${userId}`;

export function useGuidedPreparationDialog({ guides, isNewcomer, userId }: Options): UseGuidedPreparationDialogReturn {
  const [dialogState, setDialogState] = useState<DialogState>('auto');

  const alreadySeen = dialogState === 'dismissed' || (userId !== null && safeStorage.has(seenKey(userId)));
  const isOpen = guides && (dialogState === 'reopened' || (isNewcomer && !alreadySeen));

  const close = () => {
    if (userId !== null) safeStorage.remember(seenKey(userId));
    setDialogState('dismissed');
  };

  return {
    isOpen,
    source: dialogState === 'reopened' ? 'requested' : 'newcomer',
    open: () => setDialogState('reopened'),
    close,
  };
}
